import _ from 'lodash';
import { NotificationManager } from 'react-notifications';
import { Types } from '../actions/workLocationActions';

import { v4 as uuidv4 } from 'uuid';

const defaultState = {
  workLocation: {},
};

const workLocationRecuders = (state = defaultState, action) => {
  switch (action.type) {
    case Types.WORKLOCATION_DETAILED_REPORT_DOWNLOADING: {

      let newState = _.cloneDeep(state);

      // newState.workLocation.modalWorkLocation = {...newState.workLocation.modalWorkLocation};
      newState.workLocation.detailedReportDownloading = action.status

      return newState;
    }
    case Types.WORKLOCATION_BREAKDOWN_STATUS: {

      let newState = _.cloneDeep(state);

      newState.workLocation.modalWorkLocation.hoursBreakdownProcessing = action.processing
      return newState;
    }
    case Types.WORKLOCATION_BREAKDOWN: {

      let newState = _.cloneDeep(state);

      // newState.workLocation.modalWorkLocation = {...newState.workLocation.modalWorkLocation};
      newState.workLocation.modalWorkLocation.hoursBreakdown = {};

      action.payload.map(i => {
        newState.workLocation.modalWorkLocation.hoursBreakdown[i.date] = i
      })
      newState.workLocation.modalWorkLocation.hoursBreakdownProcessing = false

      return newState;
    }
    case Types.WORKLOCATION_CARRYOVER_STATUS: {
      console.log('WORKLOCATION_CARRYOVER_STATUS open');

      let newState = _.cloneDeep(state);

      newState.workLocation.carryoverProcessing = action.processing;

      if (!action.processing && newState.organisation) {
        // TODO update organisation
        newState.organisation.carryover = {
          year: new Date().getFullYear(),
        };
      }

      return newState;
    }
    case Types.WORKLOCATION_TAB: {
      let newState = _.cloneDeep(state);

      console.log('WORKLOCATION_TAB', action.tab);
      newState.workLocation.tab = action.tab;

      return newState;
    }
    case Types.WORKLOCATION_UPDATING_BALANCES: {
      let newState = _.cloneDeep(state);
      newState.workLocation.workLocationBalancesUpdating = true;
      return newState;
    }
    case Types.WORKLOCATION_UPDATE_BALANCES: {
      let newState = _.cloneDeep(state);

      console.log('WORKLOCATION_UPDATE_BALANCES', action.payload.workLocationBalances);
      newState.workLocation.workLocationBalances = action.payload.workLocationBalances;
      newState.workLocation.workLocationBalancesByType = action.payload.workLocationBalancesByType;
      newState.workLocation.workLocationBalancesUpdating = false
      newState.workLocation.proRataWorkLocation = action.payload.proRataWorkLocation

      return newState;
    }
    case Types.WORKLOCATION_UPDATING: {
      let newState = _.cloneDeep(state);

      newState.workLocation.workLocationUpdating = true;

      return newState;
    }

    case Types.WORKLOCATION_UPDATE: {
      let newState = _.cloneDeep(state);

      newState.workLocation.workLocation = action.workLocation;
      newState.workLocation.from = action.from;
      newState.workLocation.to = action.to;
      newState.workLocation.workLocationUpdating = false;
      newState.workLocation.workLocationUpdated = new Date();

      return newState;
    }
    case Types.WORKLOCATION_UPDATING_MODAL: {
      let newState = _.cloneDeep(state);

      newState.workLocation.clashingWorkLocationUpdating = true;

      return newState;
    }

    case Types.WORKLOCATION_UPDATE_MODAL: {
      let newState = _.cloneDeep(state);

      newState.workLocation.clashingWorkLocation = action.workLocation;
      newState.workLocation.clashingWorkLocationUpdating = false;

      return newState;
    }
    case Types.WORKLOCATION_UPDATING_TIMELINE: {
      let newState = _.cloneDeep(state);

      newState.workLocation.timelineWorkLocationUpdating = true;

      return newState;
    }

    case Types.WORKLOCATION_UPDATE_TIMELINE: {
      let newState = _.cloneDeep(state);

      newState.workLocation.timelineWorkLocation = action.workLocation;
      newState.workLocation.timelineWorkLocationUpdating = false;

      return newState;
    }
    case Types.WORKLOCATION_TYPES_UPDATING: {
      let newState = _.cloneDeep(state);

      newState.workLocation.workLocationTypesUpdating = true;

      return newState;
    }

    case Types.WORKLOCATION_SETTINGS_SAVING: {
      let newState = _.cloneDeep(state);

      newState.workLocation.settingsSaving = action.saving ? true : undefined;

      return newState;
    }

    case Types.WORKLOCATION_SETTINGS_SET: {
      let newState = _.cloneDeep(state);

      if (!newState.workLocation.workLocationOptions){
        newState.workLocation.workLocationOptions = {}
      }

      newState.workLocation.workLocationOptions[action.option] = action.value

      return newState;
    }
    case Types.WORKLOCATION_TYPES_UPDATE: {
      let newState = _.cloneDeep(state);

      // newState.workLocation.types = action.workLocationTypes;
      // newState.workLocation.workLocationTypesUpdating = false;

      // if (newState.workLocation.workLocationSettings) {
      //   const workLocationTypes =
      //     newState.workLocation.types &&
      //     newState.workLocation.types.map((workLocationType) => {
      //       const permissions =
      //         newState.workLocation &&
      //         newState.workLocation.workLocationSettings &&
      //         newState.workLocation.workLocationSettings.workLocationTypes &&
      //         newState.workLocation.workLocationSettings.workLocationTypes.find(
      //           (item) => item.id == workLocationType.id
      //         );

      //       const resultingWorkLocationType = {
      //         ...workLocationType,
      //         ...permissions,
      //       };

      //       return resultingWorkLocationType;
      //     });

      //   newState.workLocation.workLocationTypes = workLocationTypes;
      // }

      return newState;
    }
    case Types.WORKLOCATION_TYPES_ADD: {
      let newState = _.cloneDeep(state);

      if (!newState.workLocation.types){
        newState.workLocation.types = []
      }

      newState.workLocation.types.push({
        id: uuidv4(),
        newEntry: true
      })

      return newState;
    }
    case Types.WORKLOCATION_TYPE_DELETE: {
      let newState = _.cloneDeep(state);

      const types = newState.workLocation.types.filter(type => {
        if (type.id == action.id) {
          if (type.newEntry) return false
        }
        return true
      })

      newState.workLocation.types = types

      return newState;
    }
    case Types.WORKLOCATION_TYPES_NAME: {
      let newState = _.cloneDeep(state);

      const { workLocationType, name } = action;

      console.log('workLocationType', workLocationType, name);

      const index = newState.workLocation.types.findIndex(
        (item) => item.id == workLocationType
      );

      newState.workLocation.types[index].name = name;

      return newState;
    }
    case Types.WORKLOCATION_TYPES_PERMISSIONS: {
      let newState = _.cloneDeep(state);

      const { workLocationType, permission } = action;

      console.log('workLocationType', workLocationType, permission);

      const index = newState.workLocation.types.findIndex(
        (item) => item.id == workLocationType
      );

      newState.workLocation.types[index][permission] = !newState.workLocation.types[
        index
      ][permission];

      newState.workLocation.types.map(mappedWorkLocationType => {
        if(newState.workLocation.types.filter(I => I.defaultLocation).length > 1 && mappedWorkLocationType.id != workLocationType){
          mappedWorkLocationType.defaultLocation = false;
        }
      })

      return newState;
    }

    case Types.WORKLOCATION_SETTINGS_UPDATING: {
      let newState = _.cloneDeep(state);

      newState.workLocation.workLocationSettingsUpdating = true;

      return newState;
    }
    case Types.WORKLOCATION_SETTINGS_UPDATE: {
      let newState = _.cloneDeep(state);

      newState.workLocation.workLocationSettings = action.workLocationSettings;

      const {types,...workLocationOptions} = action.workLocationSettings

      newState.workLocation.workLocationSettingsUpdating = false;

      // use spread to put all other items in workLocation Options
      newState.workLocation.workLocationOptions = workLocationOptions;
      newState.workLocation.types = types;

      return newState;
    }

    case Types.WORKLOCATION_PERMISSIONS_UPDATING: {
      let newState = _.cloneDeep(state);

      newState.workLocation.workLocationPermissionsUpdating = true;

      return newState;
    }
    case Types.WORKLOCATION_PERMISSIONS_UPDATE: {
      let newState = _.cloneDeep(state);

      // newState.workLocation.workLocationTypes = action.workLocationTypes;
      newState.workLocation.workLocationSettingsUpdating = false;

      return newState;
    }
    case Types.WORKLOCATION_LOCK_DATE: {
      let newState = _.cloneDeep(state);

      const { date } = action;

      newState.workLocation.lockDate = date;

      return newState;
    }
    case Types.WORKLOCATION_FUTURE_LOCK_DATE: {
      let newState = _.cloneDeep(state);

      const { date } = action;

      newState.workLocation.futureLockDate = date;

      return newState;
    }

    // Start Work Location Modal/Attachment/Comments
    case Types.WORKLOCATION_ATTACHMENT_DOWNLOADING: {
      let newState = _.cloneDeep(state);

      console.log('action', action);
      newState.workLocation.downloading = newState.workLocation.downloading || [];
      newState.workLocation.downloading.push(action.key);

      return newState;
    }

    case Types.WORKLOCATION_ATTACHMENT_DOWNLOADED: {
      let newState = _.cloneDeep(state);

      console.log('action', action);
      newState.workLocation.downloading = newState.workLocation.downloading.filter(
        (key) => key != action.key
      );

      const popup = window.open(action.payload.signedURL);
      if (!popup || popup.closed || typeof popup.closed == 'undefined') {
        //Worked For IE and Firefox
        alert(
          'Popup Blocker is enabled! Please add this site to your exception list.'
        );
      }

      return newState;
    }

    case Types.WORKLOCATION_OPEN_MODAL: {
      let newState = _.cloneDeep(state);

      console.log('action', action);
      newState.workLocation.modalState = action.status;
      newState.workLocation.modalWorkLocation = action.workLocation;

      return newState;
    }

    case Types.WORKLOCATION_BALANCE_REPORT_MODAL: {
      let newState = _.cloneDeep(state);

      newState.workLocation.balanceReportModal = action.status;

      return newState;
    }

    case Types.WORKLOCATION_PIN_MODAL: {
      let newState = _.cloneDeep(state);

      newState.workLocation.workLocationPinModal = action.status;
      newState.workLocation.modalWorkLocation = action.workLocation

      return newState;
    }

    case Types.WORKLOCATION_GENERATING_BALANCE_REPORT: {
      let newState = _.cloneDeep(state);

      newState.workLocation.generatingWorkLocationBalanceReport = action.status;

      return newState;
    }

    case Types.WORKLOCATION_SHOW_CANCEL_WORKLOCATION: {
      let newState = _.cloneDeep(state);

      newState.workLocation.showCancelWorkLocation = action.workLocation;
      newState.workLocation.showCancelWorkLocationStatus = action.status;

      return newState;
    }

    case Types.WORKLOCATION_SHOW_COMMENTS: {
      let newState = _.cloneDeep(state);

      console.log('action', action);
      newState.workLocation.showComments = action.workLocation;

      return newState;
    }

    case Types.WORKLOCATION_SHOW_ATTACHMENTS: {
      let newState = _.cloneDeep(state);

      console.log('action', action);
      newState.workLocation.showAttachments = action.workLocation;

      return newState;
    }
    case Types.WORKLOCATION_SAVING: {
      let newState = _.cloneDeep(state);

      newState.workLocation.modalSaving = action.id ? true : false;
      newState.workLocation.saving = { ...newState.workLocation.saving } || [];
      newState.workLocation.saving[action.id] = true;

      return newState;
    }

    case Types.WORKLOCATION_SAVE_CURRENT: {
      let newState = _.cloneDeep(state);

      // TODO Action on add new ?? or update
      const myIndex =
        newState.workLocation &&
        newState.workLocation.workLocation &&
        newState.workLocation.workLocation &&
        newState.workLocation.workLocation.findIndex(
          (item) => item.id == action.payload.workLocation.id
        );
      if (myIndex >= 0) {
        newState.workLocation.workLocation[myIndex] = {
          ...newState.workLocation.workLocation[myIndex],
          ...action.payload.workLocation,
        };
      } else if (
        newState.workLocation &&
        newState.workLocation.workLocation &&
        newState.workLocation.workLocation
      ) {
        console.log('addToMyWorkLocation', action.payload.workLocation);
        newState.workLocation.workLocation.push(action.payload.workLocation);
        newState.workLocation.workLocation = _.orderBy(
          newState.workLocation.workLocation,
          ['start'],
          ['desc']
        );
      }

      // clear files in case of uploads
      newState.workLocation.filesUploaded = [];

      // console.log('TIMESHEET_SAVED',action)
      newState.workLocation.modalSaving = false;

      newState.workLocation.saving = { ...newState.workLocation.saving };
      delete newState.workLocation.saving[action.payload.workLocation.id];

      newState.workLocation.workLocationSaved = true;
      newState.workLocation.modalState = false;
      newState.workLocation.modalTimesheet = null;

      NotificationManager.success(
        `Your Work Location Request has been saved`,
        'Success'
      );

      return newState;
    }
    case Types.WORKLOCATION_FILE_UPLOADING: {
      let newState = _.cloneDeep(state);

      newState.workLocation.filesUploading = newState.workLocation.filesUploading
        ? [...newState.workLocation.filesUploading, action.file]
        : [action.file];

      return newState;
    }
    case Types.WORKLOCATION_FILE_UPLOADED: {
      let newState = _.cloneDeep(state);

      newState.workLocation.filesUploading = newState.workLocation.filesUploading.filter(
        (name) => name != action.file
      );

      const fileDetails = { name: action.file, key: action.key };
      newState.workLocation.filesUploaded = newState.workLocation.filesUploaded
        ? [...newState.workLocation.filesUploaded, fileDetails]
        : [fileDetails];

      NotificationManager.success(
        `${action.file} has been uploaded`,
        'Success'
      );

      return newState;
    }
    case Types.WORKLOCATION_TYPES_PIN: {
      let newState = _.cloneDeep(state);

      const { workLocationType, pos } = action;

      console.log('workLocation', workLocationType, pos);
      
      const index = newState.workLocation.types.findIndex(
        (item) => item.id == workLocationType
      );

      newState.workLocation.types[index].pos = pos;

      NotificationManager.info("Pinned location, don't forget to save!", "Pinning Location")

      return newState;
    }

    default:
      return state;
  }
};

export default workLocationRecuders;
